import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';

import Home from './Pages/Home';
import About from './Pages/About';
import Service from './Pages/Service';
import Technologies from './Pages/Technologies';
import Industries from './Pages/Industries';
import Contact from './Pages/Contact';
import NotFound from './Pages/NotFound';


const App = () => {
  return (
   
    <Router>
      <Routes>
        <Route path="/" element={<Home/>}></Route>
        <Route path="/about" element={<About/>}></Route>
        <Route path="/service" element={<Service/>}></Route>
        <Route path="/technologies" element={<Technologies/>}></Route>
        <Route path="/industries" element={<Industries/>}></Route>
        <Route path="/contact" element={<Contact/>}></Route>
        <Route path="/*" element={<NotFound/>}></Route>
        
      </Routes>
    </Router>
   
  )
}

export default App;